export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-foreground-300">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-10 py-14 md:py-16">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-8">
          <div className="col-span-2 sm:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <div className="w-9 h-9 bg-primary-500 rounded-lg flex items-center justify-center">
                <i className="ri-movie-2-fill text-background-950 text-lg"></i>
              </div>
              <span className="text-lg font-bold text-foreground-100 font-heading whitespace-nowrap">
                午马影院
              </span>
            </div>
            <p className="text-xs md:text-sm text-foreground-400 leading-relaxed">
              午马影院致力于提供电视剧大全全集高清在线播放服务，最新热播剧免费在线看，高清流畅不缓冲，经典新剧一网打尽实时更新，是千万追剧达人的首选平台。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-200 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              <li><a href="#hero" className="text-xs md:text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">首页</a></li>
              <li><a href="#carousel" className="text-xs md:text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">热门专题</a></li>
              <li><a href="#ranking" className="text-xs md:text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">热播榜单</a></li>
              <li><a href="#updates" className="text-xs md:text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">更新动态</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-200 mb-4">推荐分类</h4>
            <ul className="space-y-2.5">
              <li><a href="#index" className="text-xs md:text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">国产热播剧</a></li>
              <li><a href="#index" className="text-xs md:text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">韩剧大全</a></li>
              <li><a href="#index" className="text-xs md:text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">美剧精选</a></li>
              <li><a href="#index" className="text-xs md:text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">日剧推荐</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-200 mb-4">帮助支持</h4>
            <ul className="space-y-2.5">
              <li><a href="#faq" className="text-xs md:text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">常见问答</a></li>
              <li><a href="#contact" className="text-xs md:text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">联系我们</a></li>
              <li><a href="#about" className="text-xs md:text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">关于午马</a></li>
              <li><a href="#app" className="text-xs md:text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">移动端访问</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-200 mb-4">合作伙伴</h4>
            <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
              更多合作伙伴信息持续更新中，敬请期待。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-foreground-500/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 午马影院 · 高清追剧首选平台
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-foreground-500 cursor-pointer hover:text-primary-400 transition-colors whitespace-nowrap">服务条款</span>
            <span className="text-xs text-foreground-500 cursor-pointer hover:text-primary-400 transition-colors whitespace-nowrap">隐私政策</span>
            <span className="text-xs text-foreground-500 cursor-pointer hover:text-primary-400 transition-colors whitespace-nowrap">版权声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}